<template>
    <div class="online-card-box pd20">
        <div class="online-card">
            <div class="online-card-title">在线取卡</div>
            <el-card >
                <div class="pd20">
                    <el-form size="small" :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="rule-form" label-position="right">
                        <el-form-item label="选择卡类：" prop="product_code">
                            <el-select size="small" @change="changeProductCode" v-model="ruleForm.product_code" clearable placeholder="请选择卡类">
                                <el-option
                                   
                                    v-for="item in options.productCode"
                                    :key="item.product_code"
                                    :label="item.product_name"
                                    :value="item.product_code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="选择面值：" prop="face_value">
                            <el-select size="small" @change="changeFaceValue" v-model="ruleForm.face_value" :disabled="!ruleForm.product_code || ruleForm.product_code == ''" clearable placeholder="请选择面值">
                                <el-option
                                    v-for="item in options.faceValue"
                                    :key="item.value"
                                    :label="item.value"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="提取数量：" prop="quantity">
                            <el-input-number size="small" v-model="ruleForm.quantity" :min="1" class="form-input"></el-input-number>
                        </el-form-item>
                        <el-form-item label="所需金额：" >
                            <el-input size="small" :readonly="true" v-model="money"></el-input>
                            <div class="form-tip">可用余额：{{onlineData.balance}}</div>
                        </el-form-item>
                    </el-form>
                    <div class="card-tips">
                        说明：请仔细选择您需要提取的卡种，一旦提取成功将不能退款！
                    </div>
                    <div class="card-btn textCenter">
                        <el-button size="large" type="primary" @click="getOnlineCard" :disabled="disableOnline">确认提取</el-button>
                    </div>
                </div>
            </el-card>

            <el-card class="mt20">
            <div class="orderManage-table-div">
                <div class="table-toolbar">
                   在线提卡记录
                </div>
                <el-table ref="multipleTable" class="table-class" :data="onlineData.table.tableData" style="width: 100%;" border header-row-class-name="header-row-class-name" header-cell-class-name="header-class-name" cell-class-name="cell-class-name">
                   
                    <el-table-column prop="create_time" label="提卡时间" min-width="200px"></el-table-column> 
                    <el-table-column prop="" label="卡类"  width="180px">
                        <template scope="scope">
                            <span>{{scope.row.product_name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="face_value" label="面值" >
                        <template slot-scope="scope"> 
                            <div>¥{{scope.row.face_value}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="quantity" label="数量" ></el-table-column>
                    <el-table-column prop="total_amount" label="总金额" ></el-table-column>
                    <el-table-column label="操作" fixed="right">
                        <template slot-scope="scope">
                            <div><el-button type="text" @click="showDetail(scope.row)">详情</el-button></div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="flexX pageBox flexEnd">
                    <el-pagination :disabled="onlineData.table.loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page" :page-sizes="onlineData.table.pageSizesArr"
                        :page-size="query.size" layout="total, sizes, prev, pager, next" :total="onlineData.table.total"></el-pagination>
                </div>
            </div>
        </el-card>
       
        </div>
        <div class="dialog-box">
            <OnlineCardDetail :dialogVisible = "dialogData.dialogVisible"  :dialogObj = "dialogData.dialogObj" @closeOnlineDetail = "closeOnlineDetail"></OnlineCardDetail>
        </div>
    </div>
</template>
<script>
import OnlineCardDetail from '@/components/onlineCard/onlineCardDetail.vue'
export default {
    name: 'onlineCard',
    components:{
        OnlineCardDetail
    },
    data(){
        return {
            onlineData:{
                balance:0,
                balance_raw:'0',
                discount:1,
                loading:false, 
                table:{
                    tableData:[],
                    pageSizesArr:[10,20,30,40,50],    
                    loading:false ,
                    total:0
                }
            },
            query:{
                size:10,
                page:1,         
            },
            options:{
                productCode:[],
                faceValue:[]
            },
            ruleForm:{
                product_code:'',
                face_value:'',
                quantity:1,
            },
            rules:{
                product_code:[
                    { required: true, message: '请选择卡类', trigger: 'change' }
                ],
                face_value:[
                    { required: true, message: '请选择面值', trigger: 'change' }
                ],
                quantity:[
                    { required: true, message: '请输入数量', trigger: 'change' }
                ]
            },
            dialogData:{    
                dialogVisible:false,
                dialogObj:{}
            }

        }
    },
    computed:{
        money(){
            let money = this.ruleForm.quantity * Number(this.ruleForm.face_value) * this.onlineData.discount
            let showMoney = money+'元'
            return showMoney
        },
        disableOnline(){
            let money = this.ruleForm.quantity * Number(this.ruleForm.face_value) * this.onlineData.discount
            let disable = this.onlineData.loading || this.ruleForm.product_code=='' 
            || this.ruleForm.face_value=='' || this.ruleForm.quantity=='' || Number(this.onlineData.balance_raw)< money
            console.log( Number(this.onlineData.balance_raw))
            return disable
        },
    },
    mounted(){
        this.onlineProductList()
        this.getBalance()
        this.getCardRecords()
    },
    methods:{
        //获取卡类 产品列表
        onlineProductList(){
            this.$api.onlineProductList({}).then(res=>{
                if(res.status == 1){ 
                    this.options.productCode = res.data
                }
            })
        },
        //获取面值 
        onlineFaceValueList(){
            let data ={
                product_code: this.ruleForm.product_code
            }
            this.$api.onlineFaceValueList(data).then(res=>{
                if(res.status == 1){ 
                    this.options.faceValue = res.data
                }else{

                }
            })
        },
        //提取确认
        getOnlineCard(){            
            this.$refs["ruleForm"].validate((valid)=>{
                if(valid){
                    this.$confirm('提款后无法退款，请核对信息后进行确认', '确认提卡', {
                        confirmButtonText: '确认提取',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.takeCard()
                    })
                }else{
                    return  false;
                }
            })
            
        },
        //确认提卡 接口
        takeCard(){            
            this.onlineData.loading = true
            this.$api.takeCard(this.ruleForm).then(res=>{
                this.onlineData.loading = false
                // this.$router.push('/orderManage' )
                this.$refs['ruleForm'].resetFields();
                this.ruleForm.product_code =''
                this.ruleForm.face_value = ''
                this.getBalance()
                this.getCardRecords()
                if(res.status == 1){ 
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 3 * 1000
                    });
                }
            }).catch(err=>{
                this.onlineData.loading = false
                this.$message({
                    message: res.msg,
                    type: 'error',
                    duration: 3 * 1000
                });
            })
        },
        //选择卡类
        changeProductCode(val){
            console.log(val)
            this.ruleForm.face_value = "";
            this.onlineFaceValueList()

        },
        //选择面值
        changeFaceValue(val){
            this.onlineData.discount = 1
            for(let i = 0; i<this.options.faceValue.length; i++){
                if(val == this.options.faceValue[i].value){
                    this.onlineData.discount = this.options.faceValue[i].discount
                }
            }
        },
        //获取余额
        getBalance(){
            this.$api.getBalance({}).then(res=>{
                if(res.status == 1){ 
                    this.onlineData.balance = res.data.money_raw
                    this.onlineData.balance_raw = res.data.money_raw
                }
            })
        },
         // 订单列表查询接口
         getCardRecords(){
                this.onlineData.table.loading = true;
                this.$api.getCardRecords(this.query).then(res=>{
                    this.onlineData.table.loading = false;
                    if(res.status == 1){                        
                        this.onlineData.table.tableData = res.data.data
                        this.onlineData.table.total = res.data.total
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        });
                    }
                }).catch(e=>{
                    this.onlineData.table.loading = false;
                })
        },
        
        // 分页查询数据
        handleSizeChange(val){
            this.query.size = val;
            this.query.page = 1
            this.onlineData.table.total = 0
            this.getCardRecords()
        },
        handleCurrentChange(val){
            this.query.page = val
            this.getCardRecords()
        },
        showDetail(row){
            this.dialogData.dialogVisible= true;
            this.dialogData.dialogObj = row
        },
        closeOnlineDetail(){
            this.dialogData.dialogVisible= false;
        }

    }
}
</script>
<style scoped lang="scss">
    .online-card-box{
        .online-card{
            max-width: 800px;
            margin: 0 auto;
            box-sizing: border-box;
            .online-card-title{
                color: #303133;
                font-size: 24px;
                font-weight: 600;
                margin-bottom: 20px;
            }
            .rule-form{
                .form-input{
                    width: 215px;
                }
                .form-tip{
                    margin-top: 8px;
                    color: #909399;
                    font-size: 12px;
                }
            }
            .card-tips{
                color: #e6a23c;
                font-size: 14px;
                text-align: center;
                margin: 20px 0;
                padding: 12px;
                background: #fdf6ec;
                border-radius: 4px;
                border: 1px solid #f5dab1;
            }
        }
        .orderManage-table-div{
            .table-toolbar{
                color: #303133;
                font-size: 18px;
                font-weight: 600;

                // display: flex;
                // justify-content: space-between;
                // align-items: center;
                // margin-bottom: 16px;
                padding-bottom: 20px;
                background: #fff;
                border-bottom: 1px solid #ebeef5;
            }
            .pageBox{
                padding: 16px 20px;
                border-top: 1px solid #ebeef5;
                background-color: #fafcff;

            }
        }
    }
</style>